import { useCallback, useEffect, useRef } from 'react';

/**
 * 長押しを検知して実行するカスタムフック
 * @param {Function} callback
 * @param {number} duration
 * @returns
 */
const useLongPress = (callback: (e: any) => Promise<void> = async () => {}, duration: number = 500) => {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    const start = useCallback(
        (event: React.MouseEvent<Element> | React.TouchEvent<Element>) => {
            timeoutRef.current = setTimeout(() => {
                void callbackRef.current(event);
            }, duration);
        },
        [duration],
    );

    const clear = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);

    return {
        onMouseDown: start,
        onTouchStart: start,
        onMouseUp: clear,
        onMouseLeave: clear,
        onTouchEnd: clear,
    };
};

export default useLongPress;
